import React, { useState, useContext } from "react";
import {
  addDays,
  endOfDay,
  startOfDay,
  startOfMonth,
  endOfMonth,
  addMonths,
  startOfWeek,
  endOfWeek,
  isSameDay,
  differenceInCalendarDays,
} from "date-fns";
import { DateRangePicker } from "react-date-range";
import locale from "date-fns/locale/ru";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import Context from "../../Context";

const defineds = {
  startOfWeek: startOfWeek(new Date()),
  endOfWeek: endOfWeek(new Date()),
  startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
  endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
  startOfToday: startOfDay(new Date()),
  endOfToday: endOfDay(new Date()),
  startOfYesterday: startOfDay(addDays(new Date(), -1)),
  endOfYesterday: endOfDay(addDays(new Date(), -1)),
  startOfMonth: startOfMonth(new Date()),
  endOfMonth: endOfMonth(new Date()),
  startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
  endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
};

const staticRangeHandler = {
  get: (obj, prop) => {
    const checkIsSelected = (range) => {
      const definedRange = obj.range();
      return (
        isSameDay(range.startDate, definedRange.startDate) &&
        isSameDay(range.endDate, definedRange.endDate)
      );
    };
    switch (prop) {
      case "isSelected":
        return obj[prop] || checkIsSelected;
      default:
        return obj[prop];
    }
  },
};

export function createStaticRanges(ranges) {
  return ranges.map((range) => new Proxy(range, staticRangeHandler));
}

function DateRangePk(props) {
  const cx = useContext(Context);

  const defaultStaticRanges = createStaticRanges([
    {
      label: cx.t("common.calendar.today"),
      range: () => ({
        startDate: defineds.startOfToday,
        endDate: defineds.endOfToday,
      }),
    },
    {
      label: cx.t("common.calendar.yesterday"),
      range: () => ({
        startDate: defineds.startOfYesterday,
        endDate: defineds.endOfYesterday,
      }),
    },

    {
      label: cx.t("common.calendar.thisWeek"),
      range: () => ({
        startDate: defineds.startOfWeek,
        endDate: defineds.endOfWeek,
      }),
    },
    {
      label: cx.t("common.calendar.lastWeek"),
      range: () => ({
        startDate: defineds.startOfLastWeek,
        endDate: defineds.endOfLastWeek,
      }),
    },
    {
      label: cx.t("common.calendar.thisMonth"),
      range: () => ({
        startDate: defineds.startOfMonth,
        endDate: defineds.endOfMonth,
      }),
    },
    {
      label: cx.t("common.calendar.lastMonth"),
      range: () => ({
        startDate: defineds.startOfLastMonth,
        endDate: defineds.endOfLastMonth,
      }),
    },
  ]);

  const defaultInputRanges = [
    {
      label: cx.t("common.calendar.upToday"),
      range(value) {
        return {
          startDate: addDays(
            defineds.startOfToday,
            (Math.max(Number(value), 1) - 1) * -1
          ),
          endDate: defineds.endOfToday,
        };
      },
      getCurrentValue(range) {
        if (!isSameDay(range.endDate, defineds.endOfToday)) return "-";
        if (!range.startDate) return "∞";
        return (
          differenceInCalendarDays(defineds.endOfToday, range.startDate) + 1
        );
      },
    },
    {
      label: cx.t("common.calendar.fromToday"),
      range(value) {
        const today = new Date();
        return {
          startDate: today,
          endDate: addDays(today, Math.max(Number(value), 1) - 1),
        };
      },
      getCurrentValue(range) {
        if (!isSameDay(range.startDate, defineds.startOfToday)) return "-";
        if (!range.endDate) return "∞";
        return (
          differenceInCalendarDays(range.endDate, defineds.startOfToday) + 1
        );
      },
    },
  ];

  let startDate = props.startDate ? new Date(props.startDate) : new Date();
  let endDate = props.endDate ? new Date(props.endDate) : new Date();

  const [state, setState] = useState([
    {
      startDate: startDate,
      endDate: endDate,
      key: "selection",
    },
  ]);

  return (
    <div className={`dateRangePkHolder ${props.show ? "show" : ""}`}>
      <div className="overlay" onClick={props.closeFn}></div>
      <div className="card card-custom gutter-b">
        <div className="card-body">
          <DateRangePicker
            onClick={(e) => e.stopPropagation()}
            locale={locale}
            dateDisplayFormat="dd.MM.y"
            editableDateInputs={true}
            showPreview={false}
            weekdayDisplayFormat="EEEEEE"
            onChange={(item) => {
              setState([item.selection]);
              props.changeFn(item.selection.startDate, item.selection.endDate);
            }}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            months={1}
            ranges={state}
            direction="horizontal"
            staticRanges={defaultStaticRanges}
            inputRanges={defaultInputRanges}
          />
        </div>
      </div>
    </div>
  );
}

export default DateRangePk;
